import React, { Fragment } from 'react';
import { INFO_CARD_THEME, BOTTOM_GUTTER } from '../../../constants/patientChart.constant';

export const InfoCard = ({
  heading = 'Heading',
  bottomGutter = false,
  content = <Fragment />,
  theme = INFO_CARD_THEME.INFO,
}) => {
  return (
    <div className={`patient-chart-info-card ${theme} overflow-hidden flex flex-column ${BOTTOM_GUTTER.get(bottomGutter)}`}>
      <div className='patient-chart-info-card-heading flex flex-fill align-items-center min-height-40 font-18 bold p-l-2 p-r-2'>
        {heading}
      </div>

      <div className='patient-chart-info-card-content flex flex-column flex-fill p-l-2 p-r-2 p-t-3 p-b-3'>
        {content}
      </div>
    </div>
  );
};

export default InfoCard;
